var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-locked-warning"},[_c('span',[_vm._v(_vm._s(_vm.userName)+" a call in-progress with this client")])])}
var staticRenderFns = []

export { render, staticRenderFns }